<template>
  <section>
    <Toolbar />
    <div
      class="
        d-flex
        flex-column
        justify-center
        align-center
        mt-6 mt-xs-3 mt-sm-3 mt-md-3 mt-lg-3 mt-xl-3
        mx-5
      "
    >
      <IconoHeader />
      <v-row
        justify="center"
        class="ma-0 pa-0 mt-6 mt-xs-3 mt-sm-3 mt-md-3 mt-lg-3 mt-xl-3"
      >
        <v-col cols="12" class="ma-0 pa-0">
          <h2 class="texto-titulo text-center font-weight-bold">
            Lamentamos verte partir
          </h2>
        </v-col>
      </v-row>
      <v-row
        justify="center"
        class="ma-0 pa-0 mt-6 mt-xs-3 mt-sm-3 mt-md-3 mt-lg-3 mt-xl-3"
      >
        <v-col cols="12" class="ma-0 pa-0">
          <p class="text-body-2 text-center grey--text text--darken-2 ma-0">
            Por favor, indica la razón por la cual decides cancelar el proceso.
          </p>
        </v-col>
      </v-row>
      <v-row
        justify="center"
        class="ma-0 pa-0 mt-6 mt-xs-3 mt-sm-3 mt-md-3 mt-lg-3 mt-xl-3"
      >
        <v-col cols="12" class="ma-0 pa-0">
          <v-card class="rounded-lg py-1 px-5" elevation="3">
            <v-progress-circular
              v-if="cargando"
              :size="50"
              color="primary"
              indeterminate
            ></v-progress-circular>
            <v-radio-group
              v-if="!cargando"
              :disabled="solicitudCancelada"
              v-model="idMotivoCancelacion"
            >
              <v-radio
                v-for="motivo in obtenerMotivosCancelacion"
                :key="motivo.IdMotivo"
                :label="motivo.Descripcion"
                :value="motivo.IdMotivo"
              ></v-radio>
            </v-radio-group>
          </v-card>
        </v-col>
      </v-row>
      <v-row
        justify="center"
        class="ma-0 pa-0 mt-7 mt-xs-3 mt-sm-3 mt-md-3 mt-lg-3 mt-xl-3"
      >
        <v-col cols="12" class="ma-0 pa-0">
          <v-btn
            :disabled="solicitudCancelada"
            class="align-self-center"
            color="primary"
            elevation="3"
            @click="enviarCancelacionSolicitud"
            >ENVIAR</v-btn
          >
        </v-col>
      </v-row>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Toolbar from '@/components/compartidos/Toolbar.vue'
import IconoHeader from '@/components/compartidos/IconoHeader.vue'
import CancelacionService from '@/servicios/cancelacion'
import { ALERTA_ERROR, ALERTA_EXITO } from '@/utilidades/utilidades'

export default {
  name: 'Cancelacion',
  components: {
    Toolbar,
    IconoHeader,
  },
  data: () => ({
    idMotivoCancelacion: 2,
    cargando: true,
    solicitudCancelada: false,
  }),
  computed: {
    ...mapGetters({
      obtenerMotivosCancelacion: 'persona/obtenerMotivosCancelacion',
      obtenerFolioDigital: 'credito/obtenerFolioDigital',
    }),
  },
  methods: {
    async cargarMotivosCancelacion() {
      this.cargando = true
      let result
      try {
        result = await CancelacionService.ObtenerMotivosCancelacion()
        if (result.data.Codigo == 200 && result.data.Estado == true) {
          this.$store.dispatch('persona/establecerMotivosCancelacion', {
            motivosCancelacion: result.data.Modelo,
          })
        } else {
          this.enviarAlertaError(
            result.data.Mensaje,
            ALERTA_ERROR.tiempo,
            ALERTA_ERROR.visible
          )
        }
        this.cargando = false
      } catch {
        this.cargando = true
        this.enviarAlertaError(
          ALERTA_ERROR.mensaje,
          ALERTA_ERROR.tiempo,
          ALERTA_ERROR.visible
        )
      }
    },
    async enviarCancelacionSolicitud() {
      let result
      try {
        result = await CancelacionService.CancelarSolicitud(
          this.obtenerFolioDigital,
          this.idMotivoCancelacion
        )
        if (result.data.Codigo == 200) {
          this.enviarAlertaExito({
            mensaje:
              result.data.Mensaje +
              '. Serás redireccionado a la página de Valladolid Caja Financiera',
            tiempo: ALERTA_EXITO.tiempo,
            visibilidad: ALERTA_EXITO.visible,
          })
          this.solicitudCancelada = true
        } else {
          this.enviarAlertaError({
            mensaje: result.data.Mensaje,
            tiempo: ALERTA_ERROR.tiempo,
            visibilidad: ALERTA_ERROR.visible,
          })
        }
      } catch {
        this.enviarAlertaError({
          mensaje: ALERTA_ERROR.mensaje,
          tiempo: ALERTA_ERROR.tiempo,
          visibilidad: ALERTA_ERROR.visible,
        })
      }
      setTimeout(() => {
        window.location.href = 'https://www.cajamorelia.com.mx/'
      }, 5000)
    },
    ...mapActions({
      enviarAlertaError: 'alerta/enviarAlertaError',
      enviarAlertaExito: 'alerta/enviarAlertaExito',
    }),
  },
  created() {
    this.cargarMotivosCancelacion()
  },
}
</script>
